import { useVisibleProcessIds } from "utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { ONE_DAY_OF_MS } from "utils/timeUtils";
import { DATA_DUMP_AGGREGATE_QUERY } from "providers/MidgardProvider";
import { midgardClients } from "@raven/provisioning";
import { useServiceStatus } from "components/SimpleComponents/TopBanner/useServiceStatus";
import { useEffect, useRef, useState } from "react";
import useQueryWithErrorHandling from "utils/useQuery";
import { useMount } from "constants/constants";

/** use for debugging, on fake customers only (raveng, ravenjest) - spam Midgard DDA requests to force Midgard breaker open once */
export function ForceMidgardBreakerOpenOnce() {
  useMount(() => {
    console.log(
      "💣 ForceMidgardBreakerOpenOnce mounted - spamming Midgard DDA requests until breaker opens"
    );
  });

  const [triggered, setTriggered] = useState(false);
  const [
    {
      midgard: { breakerOpen },
    },
  ] = useServiceStatus();
  useEffect(() => {
    if (breakerOpen && !triggered) {
      setTriggered(true);
    }
  }, [breakerOpen, triggered]);

  // once the breaker has been open, stop these requests
  return triggered ? null : (
    <>
      {/* by default, the breaker opens if there are >30 failures in the last 30 seconds */}
      {[...Array(100)].map((_, i) => (
        <BigRandomMidgardDDAQuery key={i} />
      ))}
    </>
  );
}
const MAX_MIDGARD_QUERY_RANGE = 32 * ONE_DAY_OF_MS;

function BigRandomMidgardDDAQuery() {
  const ckey = useCustomerKey();
  const visibleProcessIds = useVisibleProcessIds();
  const now = useRef(Date.now()).current;
  const randBetween1And10 = useRef(1 + Math.random() * 9).current;
  const ge = now - Math.round(randBetween1And10 * 100 * ONE_DAY_OF_MS); // up to 1000 days ago

  useQueryWithErrorHandling(
    FORCE_MIDGARD_BREAKER_OPEN,
    DATA_DUMP_AGGREGATE_QUERY,
    {
      client: midgardClients.get(ckey),
      variables: {
        machemetryIds: visibleProcessIds,
        ge: `${ge}`,
        lt: `${ge + MAX_MIDGARD_QUERY_RANGE}`,
      },
    }
  );

  return null;
}
export const FORCE_MIDGARD_BREAKER_OPEN = "FORCE_MIDGARD_BREAKER_OPEN";
